import { render, staticRenderFns } from "./DepartmentSchedules.vue?vue&type=template&id=233725b0&scoped=true"
import script from "./DepartmentSchedules.vue?vue&type=script&lang=js"
export * from "./DepartmentSchedules.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSchedules.vue?vue&type=style&index=0&id=233725b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233725b0",
  null
  
)

export default component.exports